import Bugsnag from "@bugsnag/js";
import { client } from "@nju/http-client";
import { ok } from "@nju/result";
import { IGetEsimQRCodeResult } from "./types";
import { IEsimQRCode, serverResponse } from "./validators";

interface IGetEsimQRCodeProps {
  iccId: string;
  userId: string | undefined;
}

export async function getEsimQRCode({
  iccId,
  userId,
}: IGetEsimQRCodeProps): Promise<IGetEsimQRCodeResult> {
  const result = await client(
    `${process.env.NEXT_PUBLIC_PUBLIC_GATEWAY_HOST}/esims?userId=${userId}`,
    {
      headers: {
        version: "1",
        apikey: process.env.NEXT_PUBLIC_APIKEY || "unknown",
      },
      validator: serverResponse,
    },
  );

  if (result.isError) {
    Bugsnag.notify(result.err);
    return result;
  }

  const eSim = result.value.find((element) => {
    return element.iccid === iccId;
  }) as IEsimQRCode | undefined;

  return ok({
    eSim,
  });
}
